export default __webpack_public_path__ + "static/media/onboarding-aside.ff95ba58.png";